import { type ChartOptions } from 'chart.js';

import { type ChartType } from '../enums';

export const CANVAS_PADDING = 16;

const ARC_THICKNESS = 35;

export const defaultOptionDoughnutChart: ChartOptions<ChartType.Doughnut> = {
  responsive: true,
  animation: {
    duration: 0,
  },
  // size of the white circle in the middle
  cutout: `${100 - ARC_THICKNESS}%`,
  layout: {
    padding: CANVAS_PADDING,
  },
};

export const emptyDoughnutPlugin = {
  color: 'black',
  // line thickness
  width: 1,
  // distance between the empty circle and the chart data
  radiusDecrease: 0,
};
